/**
 * @module builder
 */

import type { QuoteDocument, OptionsDocument } from 'paintscout'
import get from 'lodash/get'
import type { UpdateableArea } from '../../index'
import { getQuoteType, calculateDimensions } from '../../util'
import { uuid } from '../../../util'
import { getQuoteOptions } from '../../util/get-options'

export function createArea(args?: {
  options?: OptionsDocument
  quote?: QuoteDocument
  quoteType?: string
}): UpdateableArea {
  const { quote, options } = args

  const quoteType = args.quoteType ? args.quoteType : getQuoteType({ quote })

  const quoteAreaType = get(quote, 'int_ext.defaultAreaType')
  const defaultAreaType = get(options, `options.intExtOptions.values.${quoteType}.defaultAreaType`, null)

  const quoteOptions = getQuoteOptions({ quote, options })
  const { noDefaultAreaDimensions } = quoteOptions

  let areaType: 'surface' | 'room'
  if (defaultAreaType) {
    areaType = defaultAreaType
  } else if (quoteAreaType) {
    areaType = quoteAreaType as 'surface' | 'room'
  } else if (quoteType === 'ext') {
    areaType = 'surface'
  } else {
    areaType = 'room'
  }

  const defaultDimensions = noDefaultAreaDimensions
    ? { width: 0, length: 0, height: 0 }
    : {
        width: 12,
        length: 15,
        height: 8
      }

  const dimensions = calculateDimensions({
    dimensions: defaultDimensions
  })

  return {
    key: uuid(),
    areaType,
    quoteType,
    type: 'area',
    label: '',
    dimensions,
    totals: {
      hours: {},
      prep: {},
      price: {}
    },
    clientNote: '',
    internalNote: '',
    section: 'bid',
    quantity: 1
  }
}
